<template>
  <div   class="pdf-content">
  <div class="row pdf-headers">
    <div class="col pdf-headers-item">
      <img class="user-image" src="../../../assets/images/title.png" alt="User Image" ref="userImage" />
    </div>
  </div>
  <div class="pdf-body">

    <div class="cert-description"> Kichwa Code tiene el agrado  de conferir el siguiente certificado a :</div>
    <h1 class="cert-user-name" v-html="certificate.user"> </h1>
    <h3 class="cert-objective"> Por haber finalizado satisfactoriamente </h3>
    <div class="cert-next-part"> el curso online</div>
    <h1 class="cert-title" v-html="title1"> </h1>
    <h1 class="cert-title-complete" v-html="title3"> </h1>
    <div class="cert-date" v-html="dateCertificate+certificate.dateStamp"> :</div>
    <div class="cert-brand-text" v-html="'Con la colaboracíon de: '"> :</div>

  </div>
    <div class="row cert-brand-list">
      <img class="cert-image" src="../../../assets/images/trusted-company-2.png" alt="User Image" ref="userImage" />
      <img class="cert-image" src="../../../assets/images/trusted-company-1.png" alt="User Image" ref="userImage" />
      <img class="cert-image" src="../../../assets/images/trusted-company-3.png" alt="User Image" ref="userImage" />
    </div>
  </div>
</template>

<script>
export default {
  props:{
    certificate:{
      user:String,
      dateStamp:String
    }
  },
  data() {
    return {
      user:'Pepa Papo Popote',
      title1:'aprendizaje en lógica de programación mediante '.toUpperCase(),
      title2:'mediante pseudocódigo '.toUpperCase(),
      title3:'en kichwa'.toUpperCase(),
      dateCertificate:'Realizado el dia ',
      dateStamp:new Date().toISOString('').replace('T',':').replace('Z','').replace('.','')
    };
  },

  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.$emit("domRendered");
      }, 1000);
    });
  },
};
</script>

<style lang="scss" scoped>
.pdf-content {
  width: 21.5cm;
  height: 29.5cm;
  padding: 20px;
  align-text: center;
  color: #243b55 ;
  font-family: poppins;
  background-image: url('../../../assets/images/cert_template.png');
  .pdf-headers{
    margin-left: 33%;

  }
  .cert-description{
    margin-top: 6%;
    justify-content: center;
    align-items: center;
    align-text: center;
    font-size: 2.5rem;
    margin-left: 12%;
    margin-right: 12%;


  }
  .cert-objective{
    margin-top: 6%;
    align-text: center;
    font-size: 2.5rem;
    margin-left: 7%;


  }
  .cert-next-part{
    align-text: center;
    font-size: 2.5rem;
    margin-left: 30%;
    margin-right: 20%;

  }
  .cert-user-name{
    margin-top: 3%;
    align-text: center;
    font-size: 3.5rem;
    text-decoration: underline black;
    margin-left: 33%;
    margin-right: 33%;
  }
  .cert-title{
    align-text: center;
    font-size: 2.0rem;
    margin-left: 20%;
    margin-right: 20%;
  }
  .cert-title-complete{
    align-text: center;
    font-size: 2.0rem;
    margin-left: 35%;
    margin-right: 20%;
  }
  .cert-date{
    align-text: center;
    font-size: 1.5rem;
    margin-left: 20%;
    margin-right: 20%;
    margin-bottom: 5%;
  }
  .cert-brand-text{
    align-text: center;
    font-size: 1.5rem;
    margin-left: 20%;
    margin-right: 20%;
    margin-bottom: 5%;
  }
  .cert-image{
    width: 200px;
    margin-right: 3px;
    height: 100px;
    padding: 10px
  }
  .cert-brand-list{
    margin-top: 10%;
    margin-left: 10%;
    margin-right: 10%;
  }
}
</style>
